import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"60px","text-align":"center","background":"white","color":"rgb(253, 253, 253)"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/logo.png",
    width: "50%"
  })
], -1)
const _hoisted_2 = { class: "top-bar" }
const _hoisted_3 = { style: {"text-align":"right","margin-right":"10"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lay_icon = _resolveComponent("lay-icon")!
  const _component_lay_menu_item = _resolveComponent("lay-menu-item")!
  const _component_lay_sub_menu = _resolveComponent("lay-sub-menu")!
  const _component_lay_menu = _resolveComponent("lay-menu")!
  const _component_lay_side = _resolveComponent("lay-side")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_dropdown_menu_item = _resolveComponent("lay-dropdown-menu-item")!
  const _component_lay_dropdown_menu = _resolveComponent("lay-dropdown-menu")!
  const _component_lay_dropdown = _resolveComponent("lay-dropdown")!
  const _component_lay_header = _resolveComponent("lay-header")!
  const _component_domainName = _resolveComponent("domainName")!
  const _component_appList = _resolveComponent("appList")!
  const _component_nodeIndex = _resolveComponent("nodeIndex")!
  const _component_siteList = _resolveComponent("siteList")!
  const _component_advertiseList = _resolveComponent("advertiseList")!
  const _component_announcement = _resolveComponent("announcement")!
  const _component_taskList = _resolveComponent("taskList")!
  const _component_feedbackList = _resolveComponent("feedbackList")!
  const _component_basicInfo = _resolveComponent("basicInfo")!
  const _component_setup = _resolveComponent("setup")!
  const _component_permissions = _resolveComponent("permissions")!
  const _component_role = _resolveComponent("role")!
  const _component_userList = _resolveComponent("userList")!
  const _component_paymentSettings = _resolveComponent("paymentSettings")!
  const _component_payConfig = _resolveComponent("payConfig")!
  const _component_payDetails = _resolveComponent("payDetails")!
  const _component_webUserList = _resolveComponent("webUserList")!
  const _component_accessLogList = _resolveComponent("accessLogList")!
  const _component_renewLog = _resolveComponent("renewLog")!
  const _component_lay_body = _resolveComponent("lay-body")!
  const _component_lay_layout = _resolveComponent("lay-layout")!

  return (_openBlock(), _createBlock(_component_lay_layout, { class: "example" }, {
    default: _withCtx(() => [
      _createVNode(_component_lay_side, { style: {"width":"auto","flex":"0 0 auto","align-items":"normal"} }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_menu, {
            "selected-key": $setup.selectedKey,
            "onUpdate:selectedKey": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedKey) = $event)),
            tree: $setup.isTree,
            "onUpdate:tree": _cache[1] || (_cache[1] = ($event: any) => (($setup.isTree) = $event)),
            "open-keys": $setup.openKeys6,
            "onUpdate:openKeys": _cache[2] || (_cache[2] = ($event: any) => (($setup.openKeys6) = $event)),
            onChangeSelectedKey: $setup.changeSelectedKey,
            collapse: $setup.collapse,
            style: {"padding-top":"0px"}
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuList, (menu) => {
                return (_openBlock(), _createBlock(_component_lay_sub_menu, {
                  key: menu.pathAlias,
                  id: menu.pathAlias
                }, _createSlots({
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(menu.title), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.menulist, (menu1) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: menu1.pathAlias
                      }, [
                        _createVNode(_component_lay_menu_item, {
                          id: menu1.pathAlias
                        }, {
                          title: _withCtx(() => [
                            _createTextVNode(_toDisplayString(menu1.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["id"])
                      ]))
                    }), 128))
                  ]),
                  _: 2
                }, [
                  (menu.icon != null)
                    ? {
                        name: "icon",
                        fn: _withCtx(() => [
                          _createVNode(_component_lay_icon, {
                            type: menu.icon
                          }, null, 8, ["type"])
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["id"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["selected-key", "tree", "open-keys", "onChangeSelectedKey", "collapse"])
        ]),
        _: 1
      }),
      _createVNode(_component_lay_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_lay_header, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  _createVNode(_component_lay_icon, {
                    type: $setup.collapse ? 'layui-icon-spread-left' : 'layui-icon-shrink-right',
                    size: "lg",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.menuSize($setup.collapse)))
                  }, null, 8, ["type"]),
                  _createVNode(_component_lay_icon, {
                    type: "layui-icon-home",
                    size: "lg",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.frontPage())),
                    style: {"margin-left":"20px"}
                  })
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_lay_dropdown, {
                    trigger: "hover",
                    updateAtScroll: ""
                  }, {
                    content: _withCtx(() => [
                      _createVNode(_component_lay_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_dropdown_menu_item, { onClick: $setup.changePassword }, {
                            default: _withCtx(() => [
                              _createTextVNode("修改密码")
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_lay_dropdown_menu_item, { onClick: $setup.quit }, {
                            default: _withCtx(() => [
                              _createTextVNode("退出")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_lay_button, { style: {"border-color":"transparent"} }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.userName) + " ", 1),
                          _createVNode(_component_lay_icon, {
                            type: "layui-icon-down",
                            style: {"margin-right":"10"}
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_lay_body, null, {
            default: _withCtx(() => [
              ($setup.viewsType == 2)
                ? (_openBlock(), _createBlock(_component_domainName, { key: 0 }))
                : _createCommentVNode("", true),
              ($setup.viewsType == 11)
                ? (_openBlock(), _createBlock(_component_appList, { key: 1 }))
                : _createCommentVNode("", true),
              ($setup.viewsType == 13)
                ? (_openBlock(), _createBlock(_component_nodeIndex, { key: 2 }))
                : _createCommentVNode("", true),
              ($setup.viewsType == 14)
                ? (_openBlock(), _createBlock(_component_siteList, { key: 3 }))
                : _createCommentVNode("", true),
              ($setup.viewsType == 17)
                ? (_openBlock(), _createBlock(_component_advertiseList, { key: 4 }))
                : _createCommentVNode("", true),
              ($setup.viewsType == 18)
                ? (_openBlock(), _createBlock(_component_announcement, { key: 5 }))
                : _createCommentVNode("", true),
              ($setup.viewsType == 20)
                ? (_openBlock(), _createBlock(_component_taskList, { key: 6 }))
                : ($setup.viewsType == 22)
                  ? (_openBlock(), _createBlock(_component_feedbackList, { key: 7 }))
                  : ($setup.viewsType == 1)
                    ? (_openBlock(), _createBlock(_component_basicInfo, { key: 8 }))
                    : ($setup.viewsType == 4)
                      ? (_openBlock(), _createBlock(_component_setup, { key: 9 }))
                      : ($setup.viewsType == 6)
                        ? (_openBlock(), _createBlock(_component_permissions, { key: 10 }))
                        : ($setup.viewsType == 7)
                          ? (_openBlock(), _createBlock(_component_role, { key: 11 }))
                          : ($setup.viewsType == 9)
                            ? (_openBlock(), _createBlock(_component_userList, { key: 12 }))
                            : ($setup.viewsType == 6)
                              ? (_openBlock(), _createBlock(_component_paymentSettings, { key: 13 }))
                              : ($setup.viewsType == 25)
                                ? (_openBlock(), _createBlock(_component_payConfig, { key: 14 }))
                                : ($setup.viewsType == 24)
                                  ? (_openBlock(), _createBlock(_component_payDetails, { key: 15 }))
                                  : ($setup.viewsType == 26)
                                    ? (_openBlock(), _createBlock(_component_webUserList, { key: 16 }))
                                    : ($setup.viewsType == 28)
                                      ? (_openBlock(), _createBlock(_component_accessLogList, { key: 17 }))
                                      : ($setup.viewsType == 29)
                                        ? (_openBlock(), _createBlock(_component_renewLog, { key: 18 }))
                                        : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}